import { render, staticRenderFns } from "./promotionLink.vue?vue&type=template&id=a76575da&scoped=true"
import script from "./promotionLink.vue?vue&type=script&lang=js"
export * from "./promotionLink.vue?vue&type=script&lang=js"
import style0 from "./promotionLink.vue?vue&type=style&index=0&id=a76575da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76575da",
  null
  
)

export default component.exports